/**
 * A helper class for returning optional options from a Function.
 */
export class FunctionResultOptions {
  // #region Properties (4)
  error_type;
  message;
  pageToken;
  totalRows;
}
export function createFunctionResultOptions(message, totalRows, error_type, pageToken) {
  const result = new FunctionResultOptions();
  result.error_type = error_type;
  result.message = message;
  result.pageToken = pageToken;
  result.totalRows = totalRows;
  return result;
}